import { Alert, BetaPill, Button, DatevLogo, ToggleContainer } from '@components'
import { useShowDatevComingSoon } from '@hooks'
import React from 'react'
import { FaDownload, FaUpload } from 'react-icons/fa'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

export const DatevPeriodComingSoon: React.FC = () => {
  const { t } = useTranslation()
  const showDatevComingSoon = useShowDatevComingSoon()

  if (!showDatevComingSoon) {
    return null
  }

  return (
    <Wrapper>
      <ToggleContainer
        title={
          <TitleRow>
            <DatevLogo height={20} />
            <span>{t('period.datev.title')}</span>
            <BetaPill
              label={t('general.comingSoon.label')}
              tooltip={t('general.comingSoon.tooltip')}
            />
          </TitleRow>
        }
        openByDefault={true}
      >
        <Alert
          type="info"
          marginBottom={0}
          title={t('period.datev.comingSoonTitle')}
          description={t('period.datev.comingSoonDescription')}
        />
        <Actions>
          <Button type="button" size="sm" intent="primary" icon={<FaUpload />} disabled>
            {t('period.datev.export')}
          </Button>
          <Button type="button" size="sm" intent="primary" icon={<FaDownload />} disabled>
            {t('period.datev.closing')}
          </Button>
        </Actions>
      </ToggleContainer>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  margin-top: ${({ theme }) => theme.spacing.lg}rem;
`

const TitleRow = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm}rem;
`

const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing.sm}rem;
  margin-top: ${({ theme }) => theme.spacing.md}rem;
`
